import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { useParams } from "react-router-dom";
import plusicon from "../../../assets/img/product_img/plusicon.png";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../Breadcrumb";
import bannerIMG from "../../../../src/assets/bannerImages/main-img.jpg";
import childImg1 from "../../../assets/img/child-img/indoor playground square fit 1.png";
import childImg2 from "../../../assets/img/child-img/indoor playground square fit 2.png";
import childImg3 from "../../../assets/img/child-img/indoor playground square fit 3.png";
import childImg4 from "../../../assets/img/child-img/indoor playground square fit 4.png";
import { Helmet } from "react-helmet-async";
import WhatsappButton from "../../../components/WhatsappButton";

const InteractivegamesProduct = () => {
  const { type } = useParams();
  console.log(type);
  let content;

  if (type === "MarioJump") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor playground design"
            className="main-img"
          ></img>
        </div>
       
        <h1 className="p-heading">Mario Jump</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
          <h2
              style={{
                color: '#000000',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '26px',
                letterSpacing: '2%',
              }}
            >
             Mario Jump is an interactive gaming platform featuring a variety of exciting games suitable for both children and adults. These games provide a perfect mix of fun and challenge, making them enjoyable for everyone who loves to jump. By combining jumping with cutting-edge technology and ensuring safety, Mario Jump delivers an engaging experience for all ages. This innovative platform offers trampoline parks a significant boost in entertainment value and can be seamlessly integrated into their facilities.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                <b>Large Display with Motion Sensors</b>– The game features a massive display equipped with motion sensors that detect players' movements in real time.{" "}
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                <b>Live Video Integration</b> – Sensors capture live videos of players and seamlessly integrate them into the game, creating an immersive experience.
                </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>

                <b>Virtual Reality Feel</b> – Players will feel like they are inside the big screen, enhancing the sense of presence in a virtual world.
                </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>

                <b>High-Quality Sound</b> – The game delivers rich, high-quality sound effects, amplifying the excitement and immersion.
                </h2>
              </li>
            </ul>
            <h3 className="p-sub-heading-2">Who Can Benefit?</h3>
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>

                <b>Trampoline Park Visitors</b> – Experience thrilling, worry-free landings.
                </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                <b>Athletes & Stunt Performers</b> – Safely practice high jumps and advanced moves.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Freestyle Enthusiasts</b> – Push the limits of aerial tricks with confidence.
                </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                <b>Gaming Enthusiasts</b> – Enjoy a next-level interactive experience that blends gaming and physical activity.
                </h2>
              </li>
              <h3 className="p-sub-heading-2">
              Why Global Entertainment Manufacturer?
              </h3>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              With years of expertise in trampoline park equipment, we ensure innovation, safety, and premium quality in every product
              </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playground equipment catalog" />
              <img src={childImg3} alt="indoor playground" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor playground design" />
              <img src={childImg4} alt="indoor playground" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "JumpnTouch") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment company"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading"> Jump’n Touch</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
          <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
            Jump'n Touch is an exhilarating game that combines a trampoline mat with an interactive wall featuring 10 physical buttons, each set of 5 assigned a unique LED color, along with a large scoring display. As a leading Soft Play Supplier in Jordan, we provide high-quality, safe, and engaging play solutions designed to enhance interactive fun for all ages.
          </h2>

          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">              
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Designed for two players, the game kicks off with the LED lights on the buttons blinking rapidly.
                </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Players must jump and touch the buttons as quickly as they can.
              </h2>
              </li>

              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                The winner is the player who touches the most buttons within the allotted time.
              </h2>
              </li>

              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Jump'n Touch delivers a thrilling mix of speed, coordination, and fun, making it a standout attraction in any trampoline park.
              </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playgrounds" />
              <img src={childImg3} alt="kids playground" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="playground equipment catalog" />
              <img src={childImg4} alt="playground equipment suppliers" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "ChallengerTrampoline") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor commercial playground"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Challenger Trampoline</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
          <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
            Challenger Trampoline is a competitive game where two players aim to score points by shooting the ball into their opponent's goal while jumping on a trampoline (Family Entertainment Centers Manufacturer in jordan)
          </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  The objective is to accumulate as many points as possible within a specified time or until a certain score is reached.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  The player with the higher score at the end of the game is declared the winner.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  The game elements of jumping and precision aiming, adding an exciting and dynamic element to traditional goal-scoring competitions.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playground equipment manufacturers" />
              <img src={childImg3} alt="trampoline park with soft play" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="playgrounds" />
              <img src={childImg4} alt="soft play" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "SpeedyLight") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="trampoline company"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Speedy Light</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
            Speedy Light is an exciting two-player reaction game designed for indoor playgrounds. Featuring nine touch-sensitive LED buttons per player and a large LED scoreboard, it challenges players to tap the lights as fast as possible to score points.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  The faster you react, the higher your score, the quickest player wins!{" "}
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  At Global Entertainment Manufacturer, we focus on innovation, durability, and interactive play, making Speedy Light a perfect addition to any indoor play area.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Bring fast-paced fun to your playground today
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="trampoline parks" />
              <img src={childImg3} alt="trampoline park with soft play" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="soft play and trampoline" />
              <img src={childImg4} alt="soft play and trampoline" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "DodgeBall") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="trampoline parks"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Dodge Ball</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
            Dodgeball trampoline is a variation of dodgeball that is played on trampoline. It combines the traditional game of dodgeball with the added challenge and excitement of bouncing on a trampoline.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              GEM Dodgeball trampolines are larger than standard trampolines, as they need to accommodate multiple players, also the springs are stronger as they need to provide a higher bounce to allow for the unique maneuvers required in the game.
              </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                To ensure the safety of players, our dodgeball trampolines have padding around the frame and other areas to protect players from impact.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="indoor family entertainment center" />
              <img src={childImg3} alt="indoor playground design" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor play equipment commercial" />
              <img src={childImg4} alt="playground equipment company" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "DiscoDancer") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img src={bannerIMG} alt="soft play" className="main-img"></img>
        </div>
        <h1 className="p-heading">Disco Dancer</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
           <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
            Disco Dancer is a thrilling two-player dance challenge designed for indoor playgrounds. Featuring a touch-sensitive LED floor and a large LED scoreboard, players must step on the lights as fast as possible to earn points.                             
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                The quicker you move, the higher your score—the fastest dancer wins!
                </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              At Global Entertainment Manufacturer, we combine fun, technology, and durability to create engaging interactive experiences.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Add Disco Dancer to your playground for non-stop energy and excitement
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playgrounds and parks" />
              <img src={childImg3} alt="indoor playground with slide" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="trampoline park with soft play" />
              <img src={childImg4} alt="playground equipment suppliers" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "GEMSlicer") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment catalog"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">GEM Slicer</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
          <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
            GEM Slicer is an exciting multi-touch screen game designed for kids in indoor playgrounds. Featuring a large 32” high-quality touch screen and immersive sound effects, it offers a fast-paced, interactive experience that keeps kids engaged and entertained.                            
          </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                At Global Entertainment Manufacturer, we specialize in Indoor Playground Production in Jordan, creating thrilling and durable digital play solutions to enhance indoor playgrounds. Add GEM Slicer to your play area for endless fun and excitement.
              </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="soft play installation" />
              <img src={childImg3} alt="highest quality trampoline" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor playground with slide" />
              <img src={childImg4} alt="indoor commercial playground" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "WallThrowGame") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment manufacturers"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Wall Throw Game</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
          <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
          Wall Throw Game is an interactive projector-based throw game designed for ball pool areas in indoor playgrounds. Players throw soft balls at the screen to hit targets, engaging in 20 exciting game modes for endless fun.
          </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                The multi-touch responsive screen ensures a dynamic and immersive experience.
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                At Global Entertainment Manufacturer, we combine technology, innovation, and durability to create engaging play solutions.
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Add Wall Throw Game to your playground for interactive and active fun
              </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img
                src={childImg1}
                alt="playTurn on screen reader supportground equipment catalog
"
              />
              <img src={childImg3} alt="playground equipment suppliers" />{" "}
            </div>
            <div className="p-img-left-box">
              <img
                src={childImg2}
                alt="commercial indoor playground equipment"
              />
              <img src={childImg4} alt="playgrounds" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "BeeTree") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor commercial playground"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Bee Tree</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
          <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
          Bee Tree is a fun and interactive self-rotating carousel game designed for indoor playgrounds. Up to six children (ages 4-10) can enjoy the ride together, with an adjustable rotating speed for safety. Made from durable and child-safe materials, Bee Tree ensures a secure and exciting play experience.
          </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                At Global Entertainment Manufacturer, we prioritize quality, safety, and fun. As a leader in Indoor Playground Production in Jordan and a top Challenge Game Manufacturer, we ensure Bee Tree is a perfect addition to any indoor play area
              </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="highest quality trampoline" />
              <img src={childImg3} alt="indoor commercial playground" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor playground" />
              <img src={childImg4} alt="playground equipment catalog" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "Hamster") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor commercial playground"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Hamster</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                At Global Entertainment Manufacturer, we prioritize quality, safety, and fun. As a leading Challenge Game Manufacturer in Jordan, we ensure Bee Tree is a perfect addition to any indoor play area, with expert Soft Play Installation in Jordan for a seamless and secure setup.
              </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                At Global Entertainment Manufacturer, we focus on innovation, safety, and durability, making Hamster a perfect addition to any indoor playground
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Built with high-quality, durable materials, Hamster ensures safety and long-lasting performance.
              </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img
                src={childImg1}
                alt="commercial indoor playground equipment"
              />
              <img src={childImg3} alt="playground equipment manufacturers" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="trampoline company" />
              <img src={childImg4} alt="playground equipment company" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "AirBall") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="playground equipment company"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading">Air Ball</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              At Global Entertainment Manufacturer (GEM), we bring cutting-edge innovation to indoor playgrounds and trampoline parks. As a leading Climbing Wall Manufacturer in Jordan, we offer exciting attractions like our Air Ball game—an interactive experience that blends skill, agility, and fun, keeping players engaged and entertained for hours.
              </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">Why Choose Air Ball?</h3>
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Interactive & Engaging – Encourages teamwork, hand-eye coordination, and strategic thinking.  
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Safe & Kid-Friendly – Designed with soft, impact-resistant materials, ensuring a fun and secure play experience
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Customizable Setup – Available in various sizes, colors, and configurations to fit your indoor play space.
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Attractive for All Ages – Whether for kids or families, Air Ball is a crowd favorite that keeps visitors coming back.
              </h2>
              </li>
              <h3 className="p-sub-heading-2">Perfect for Any Play Area</h3>

              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Air Ball is an ideal addition to trampoline parks, adventure centers, and family entertainment venues. It enhances interactive play, encourages social engagement, and provides an immersive gaming experience that appeals to all age groups
              </h2>
              </li>

              <h3 className="p-sub-heading-2">
                Upgrade Your Entertainment Space Today
              </h3>

              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Take your indoor playground to the next level with Air Ball! Contact Global Entertainment Manufacturer (GEM) and let’s create an unforgettable experience together.
              </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="soft play installation" />
              <img src={childImg3} alt="indoor commercial playground" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="kids playground" />
              <img src={childImg4} alt="playground equipment manufacturers" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "BallBlaster") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img src={bannerIMG} alt="playgrounds" className="main-img"></img>
        </div>
        <h1 className="p-heading">Ball Blaster</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                At Global Entertainment Manufacturer (GEM), we design thrilling attractions that turn ordinary play into extraordinary adventures! As a leading Trampoline Park Manufacturer in Jordan, we offer the exciting Ball Blaster game—an action-packed experience that brings excitement, teamwork, and skill-based fun to indoor playgrounds and trampoline parks.
              </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">What is Ball Blaster?</h3>
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Ball Blaster is an interactive shooting game where players use air-powered blasters to shoot soft foam balls at targets, baskets, or even opponents in a safe and competitive environment. The game enhances reflexes, accuracy, and coordination while ensuring non-stop fun for all ages!
                </h2>
              </li>

              <h3 className="p-sub-heading-2">Why Choose Ball Blaster?</h3>
              <br />
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Fast-Paced & Interactive – Encourages friendly competition and keeps players actively engaged.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Safe & Soft Foam Balls – Made with premium, lightweight materials to ensure a fun and secure play experience.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Customizable Arena – Available in various themes, colors, and sizes to match your playground or trampoline park.
                </h2>
              </li>

              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Perfect for All Ages – Kids and adults alike can join the fun, making it a crowd-favorite attraction.
                </h2>
              </li>
            </ul>
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Ball Blaster is a must-have for trampoline parks, adventure centers, and family entertainment venues. It boosts visitor engagement, promotes teamwork and social interaction, and creates an unforgettable experience for players of all skill levels.
                </h2>
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Upgrade your entertainment space with Ball Blaster and give your visitors an experience they’ll love! Contact Global Entertainment Manufacturer (GEM) to bring ultimate action to your indoor playground
                </h2>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playground equipment manufacturers" />
              <img src={childImg3} alt="indoor playground design" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor playground" />
              <img src={childImg4} alt="indoor playground design" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (type === "MiniBowling") {
    content = (
      <div className="p-container">
        <div
          className="p-img-box"
          style={{ position: "relative", display: "inline-block" }}
        >
          <div
            className="breadcrumb-overlay"
            style={{
              position: "absolute",
              top: "105%",
              left: "20%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Breadcrumb textColor="#000" />
          </div>
          <img
            src={bannerIMG}
            alt="indoor playground"
            className="main-img"
          ></img>
        </div>
        <h1 className="p-heading"> Mini Bowling</h1>
        <div className="p-heading-p-heading">
          <div className="p-heading-p-text">
            <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              At Global Entertainment Manufacturer (GEM), we bring next-level
              excitement to indoor playgrounds with our innovative Mini Bowling
              game! Designed specifically for kids, this interactive game
              combines the thrill of bowling with soft, safe play elements,
              making it a perfect addition to family entertainment centers and
              trampoline parks.
            </h2>
          </div>
        </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">What is Mini Bowling?</h3>
            <ul typeof="text-box">
              <li className="text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Mini Bowling is an exciting target-based bowling game where
                players throw a soft ball at multiple targets. A huge LED
                display enhances the experience by tracking and displaying
                scores in real time, adding an element of competition and
                engagement. Made with soft foam and high-quality fabrication
                materials, Mini Bowling is designed to be 100% safe and
                non-harmful, making it an ideal game for young players
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  High Durability – Made with reinforced materials for
                  long-lasting performance.
                </h2>
              </li>
              <h3 className="p-sub-heading-2">Why Choose Mini Bowling?</h3>
              <br />
              <li className="p-text-2">
                
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Safe & Kid-Friendly – Made with soft foam materials, ensuring a
                  risk-free play experience
                </h2>
              </li>
              <li className="p-text-2">
                
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Multiple Target Challenges – Players must aim and hit different
                  targets, improving accuracy, coordination, and motor skills.
                </h2>
              </li>
              <li className="p-text-2">
                
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Perfect for Indoor Playgrounds – Designed for kids’
                  entertainment zones, trampoline parks, and adventure play areas.
                </h2>
              </li>
              <li className="text-2">
                

                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Mini Bowling is a fun, engaging, and safe game that encourages
                  friendly competition and active play. Its bright, interactive
                  setup makes it an eye-catching centerpiece in any indoor
                  playground.
                </h2>
              </li>
              <li className="text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Upgrade your play area with Mini Bowling and create an
                  unforgettable experience for young players! Contact Global
                  Entertainment Manufacturer (GEM) to add this exciting game to
                  your indoor playground.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playground equipment company" />
              <img src={childImg3} alt="playgrounds" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="kids playground" />
              <img src={childImg4} alt="playground equipment catalog" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div>
        {/* Whats App Icon */}
        <WhatsappButton
            altText="Chat with us on WhatsApp"
            iconSize={70}
          />
        <Link
          to="/getquotations"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="icon-container">
            <img
              src={plusicon}
              alt="playground equipment suppliers"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>
      </div>
      {content}
      <Footer />
    </div>
  );
};

export default InteractivegamesProduct;
